import React, { useRef, useEffect, useState } from 'react';
import { EffectCards } from 'swiper/modules';
import styled from 'styled-components';
import Cross from '../assets/img/xmark.svg';
import Button from '../components/Button';
import BigMac from '../assets/img/big-mac.png';
import Words from '../assets/img/words.png';
import ChipsCoke from '../assets/img/chips-coke.png';

import { register } from 'swiper/element/bundle';
register();

const OnboardingTapDiv = styled.div`
  .image {
    width: 100%;
    margin-top: 24px;
  }
  .image-2 {
    margin-top: 0;
    margin-bottom: 24px;
  }
  .image-3 {
    margin-top: 0;
  }
  .swiper-cards {
    height: 335px;
    display: none;
  }
  .continue-btn {
    margin-top: 24px;
  }

  swiper-container {
    width: 268px;
    height: 335px;
  }
  swiper-slide {
    border-radius: 16px;
    -webkit-touch-callout:none;
    -webkit-user-select:none;
    -khtml-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
  }
  .swiper-slide-shadow {
    display: none;
  }

  swiper-slide img {
    -webkit-touch-callout:none;
    -webkit-user-select:none;
    -khtml-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
  }

  .close-btn {
    border: none;
    border-radius: 50%;
    width: 44px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0;
    margin-left: auto;
  }

  h1 {
    font-family: 'Speedee Bold';
    font-size: 48px;
    line-height: 0.95;
    letter-spacing: -1.44px;
    margin-bottom: 24px;
    margin-top: 8px;
  }

  .step {
    width: 264px;
    height: 330px;
    border-radius: 16px;
    border: 2px solid #ffbc0d;
    box-shadow: 0px 14px 25px 0px rgba(0, 0, 0, 0.15);
    align-items: center;
    background: #fff;

    .number {
      font-family: 'Speedee Bold';
      font-size: 108px;
      line-height: 95%;
      letter-spacing: -0.715px;
      font-weight: 700;
      color: #e6a65d;
    }

    .number-2 {
      color: #a9c23f;
    }

    .number-3 {
      color: #ffbc0d;
    }

    .top {
      display: flex;
      padding: 8px;
    }

    .card-content {
      padding: 8px;
    }

    .card-title {
      margin-top: 0;
      margin-bottom: 4px;
      font-family: 'Speedee Bold';
      font-size: 24px;
      line-height: 22.8px;
      letter-spacing: -0.15px;
    }
    p {
      margin-top: 0;
      font-size: 15px;
      line-height: 1.25;
      letter-spacing: -0.3px;
    }
  }
  .carousel-navigation {
    margin-top: 24px;
    height: 10px;
    display: flex;
    justify-content: center;
  }
  .dot {
    height: 10px;
    width: 10px;
    margin: 0 5px;
    background-color: #e1e1e1;
    border-radius: 50%;
    display: inline-block;
    transition: background-color 0.3s ease;

    &.active {
      background-color: #ffbc0d;
    }
  }
`;
const OnboardingTap = ({ ...props }) => {
  const { setPage } = props;
  const [continueBtnClickedCount, setContinueBtnClickedCount] = useState(0);
  const swiperElRef = useRef(null);
  const continueRef = useRef(null);

  useEffect(() => {
    // listen for Swiper events using addEventListener
    swiperElRef.current.addEventListener('swiperslidechange', (e) => {
      setContinueBtnClickedCount(swiperElRef.current.swiper.activeIndex);
    });
  }, []);

  const continueClick = () => {
    if (
      continueBtnClickedCount < 2 &&
      swiperElRef.current.swiper.activeIndex < 2
    ) {
      swiperElRef.current.swiper.slideNext();
      setContinueBtnClickedCount(continueBtnClickedCount + 1);
    } else if (
      continueBtnClickedCount === 2 &&
      swiperElRef.current.swiper.activeIndex === 2
    ) {
      setPage('ready-tap');
    }
  };

  const closeOnboarding = () => {
    setPage('ready-tap');
  };

  const navigateCarousel = (idx) => {
    if (swiperElRef && swiperElRef.current) {
      swiperElRef.current.swiper.slideTo(idx);
    }
  };

  return (
    <OnboardingTapDiv>
      <div>
        <button onClick={closeOnboarding} className="close-btn">
          <img src={Cross} alt="cross" />
        </button>
        <h1>How to play</h1>
        <swiper-container
          effect={'cards'}
          grabCursor={true}
          modules={[EffectCards]}
          ref={swiperElRef}
          className="swiper-container">
          <swiper-slide>
            <div className="step">
              <div className="top">
                <span className="number number-1">1</span>
                <div className="card-content">
                  <h2 className='card-title'>Memorise</h2>
                  <p>
                  You know the Big Mac, but do you know the chant?
                  </p>
                </div>
              </div>
              <img className="image image-1" src={BigMac} alt="big mac" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div className="step">
              <div className="top">
                <span className="number number-2">2</span>
                <div className="card-content">
                  <h2 className='card-title'>Tap the chant</h2>
                  <p>
                    After the countdown, tap the Big Mac ingredients in the
                    correct order!
                  </p>
                </div>
              </div>
              <img className="image image-2" src={Words} alt="words" />
            </div>
          </swiper-slide>
          <swiper-slide>
            <div className="step">
              <div className="top">
                <span className="number number-3">3</span>
                <div className="card-content">
                  <h2 className='card-title'>Get rewarded</h2>
                  <p>
                    Complete the chant in 4 seconds to win a free Small Fries
                    and Coke®.
                  </p>
                </div>
              </div>
              <img
                className="image image-3"
                src={ChipsCoke}
                alt="chips and coke"
              />
            </div>
          </swiper-slide>
        </swiper-container>
        <div className="carousel-navigation">
          {Array(3)
            .fill()
            .map((_, index) => (
              <span
                key={index}
                className={`dot ${
                  swiperElRef.current?.swiper.activeIndex === index ||
                  continueBtnClickedCount === index
                    ? 'active'
                    : ''
                }`}
                onClick={() => {
                  navigateCarousel(index);
                }}></span>
            ))}
        </div>
        <div className="continue-btn" ref={continueRef} onClick={continueClick}>
          <Button>Continue</Button>
        </div>
      </div>
    </OnboardingTapDiv>
  );
};

export default OnboardingTap;
